import SimpleCalloutRepository from "../SimpleCalloutRepository"

export default class FeatureSimpleCallout extends SimpleCalloutRepository {
    static schemaId = "feature_simpleCallout"

    constructor() {
        super(FeatureSimpleCallout.schemaId)
    }
}
